module.exports = __webpack_public_path__ + "static/media/EST.e83014a6.png";